import * as BABYLON from "babylonjs";
export function meshoutline(mesh, type) {
  mesh.outlineColor = BABYLON.Color3["Green"]();
  let outlineWidth = mesh.getBoundingInfo().boundingSphere.radius / 30;
  mesh.outlineWidth = outlineWidth
  mesh.renderOutline = type;
}

export function meshInsMouseIn(meshIns, type) {
  let activecolor = BABYLON.Color3.Green()
  let warncolor = BABYLON.Color3.Red()
  let origincolor = new BABYLON.Color3(1, 1, 1)
  let statcolor = meshIns.oldcolor || origincolor
  let color = meshIns.instancedBuffers.color
  if (color.r == 1 && color.g == 0 && color.b == 0) {
    meshIns.instancedBuffers.color = warncolor
  } else {
    meshIns.instancedBuffers.color = type ? activecolor : statcolor
  }
}
export function meshMouseIn(mesh, type) {
  // if(!mesh.$oldcolor){
  //   mesh.$oldcolor = mesh.material.albedoColor.clone()
  // }
  // mesh.material.albedoColor = type?BABYLON.Color3.Green():mesh.$oldcolor
}



// WEBPACK FOOTER //
// ./src/components/webgl/LevelsShow/Tools/mesheffect.js